import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PictureCategoryState } from "../objects/pictureCategoryState";
import { PictureCategoryItem } from "../objects/pictureCategoryItem";
import { EMPTY_PICTURE_CATEGORY_LIST_CRITERIA } from "../constants/pictureCategoryConstants";
import { PictureCategoryListCriteria } from "../objects/pictureCategoryList";

const initialState: PictureCategoryState = {
    picture_category_list: [],
    picture_category_list_count: 0,
    picture_category_list_criteria: EMPTY_PICTURE_CATEGORY_LIST_CRITERIA,
    picture_category_list_loading: false,
    picture_category: null,
    picture_category_delete: null,
};

const setPictureCategoryListReducer = (state: PictureCategoryState, action: PayloadAction<PictureCategoryItem[]>): PictureCategoryState => ({
    ...state, picture_category_list: action.payload
});
const setPictureCategoryListCountReducer = (state: PictureCategoryState, action: PayloadAction<number>): PictureCategoryState => ({
    ...state, picture_category_list_count: action.payload
});
const setPictureCategoryListLoadingReducer = (state: PictureCategoryState, action: PayloadAction<boolean>): PictureCategoryState => ({
    ...state, picture_category_list_loading: action.payload
});
const setPictureCategoryReducer = (state: PictureCategoryState, action: PayloadAction<PictureCategoryItem | null>): PictureCategoryState => ({
    ...state, picture_category: action.payload
});
const setPictureCategoryDeleteReducer = (state: PictureCategoryState, action: PayloadAction<PictureCategoryItem | null>): PictureCategoryState => ({
    ...state, picture_category_delete: action.payload
});
const setPictureCategoryListCriteriaReducer = (state: PictureCategoryState, action: PayloadAction<PictureCategoryListCriteria>): PictureCategoryState => ({
    ...state, picture_category_list_criteria: action.payload
});

export const pictureCategory = createSlice({
    name: 'picture_category',
    initialState,
    reducers: {
        setPictureCategoryList: setPictureCategoryListReducer,
        setPictureCategoryListCount: setPictureCategoryListCountReducer,
        setPictureCategoryListLoading: setPictureCategoryListLoadingReducer,
        setPictureCategory: setPictureCategoryReducer,
        setPictureCategoryDelete: setPictureCategoryDeleteReducer,
        setPictureCategoryListCriteria: setPictureCategoryListCriteriaReducer
    }
});

export const {
    setPictureCategoryList,
    setPictureCategoryListCount,
    setPictureCategoryListLoading,
    setPictureCategory,
    setPictureCategoryDelete,
    setPictureCategoryListCriteria
} = pictureCategory.actions;
